export type FeatureFlag =
  | 'print-mail'
  | 'calls'
  | 'channel-mix'
  | 'brand-kit'
  | 'safety-training'
  | 'insurance-verification'
  | 'insurance-verification-legacy'
  | 'review-sms'
  | 'community'
  | 'classic-agent-tasks'
  | 'patient-referrals';

// Add practiceIds to grant access per flag NOT in PRACTICE_FEATURE_FLAGS below.
const FEATURE_GATES: Record<FeatureFlag, string[]> = {
  // S1.2: Channel Mix and Print & Mail are shown to no practice — pages and routes
  // stay, only the gate is empty. See the Stage 1 cleanup spec.
  // Stage 3/R.4: brand-kit and calls moved to PRACTICE_FEATURE_FLAGS below (per-practice registry);
  // this list stays empty for all 4 so only the registry can turn them on.
  'channel-mix': [],
  'brand-kit': [],
  'print-mail': [],
  calls: [],
  // Safety & Training: per practice from Command Center → Modules → Safety & training.
  'safety-training': [],
  // Toggled per practice from the Command Center Admin tab (see
  // PRACTICE_FEATURE_FLAGS below), not from this list. The practices that
  // used to be listed here were grandfathered by a data migration.
  'insurance-verification': [],
  // OLD Insurance Verification screens: per practice from Command Center → Modules → Insurance verification.
  'insurance-verification-legacy': [],
  // Text review requests (PRD 5 §4.7): per practice from Command Center → Modules → Reviews.
  'review-sms': [],
  // Community & Referrals (Joe): per practice from Command Center → Modules → Community.
  community: [],
  // The original tabbed task view (the conversation view is the default): per practice from Command Center → Agents.
  'classic-agent-tasks': [],
  // Patient Referrals (Operations › Referrals): per practice from Command Center → Modules → Patient referrals.
  'patient-referrals': [],
};

/**
 * Flags stored per practice in `Practice.featureFlags` (off by default) and
 * switched from the Command Center → practice → Admin → Feature flags. A flag
 * listed here is read from the practice record; any other flag uses the
 * hard-coded allow-list above.
 */
const PRACTICE_FEATURE_FLAGS: Partial<Record<FeatureFlag, string>> = {
  'insurance-verification': 'insuranceVerification',
  'insurance-verification-legacy': 'legacyInsuranceVerification',
  'channel-mix': 'channelMix',
  'brand-kit': 'brandKit',
  'print-mail': 'printMail',
  calls: 'calls',
  'review-sms': 'reviewsSms',
  community: 'community',
  'safety-training': 'safetyTraining',
  'classic-agent-tasks': 'classicAgentTasks',
  'patient-referrals': 'patientReferrals',
};

export { FEATURE_GATES, PRACTICE_FEATURE_FLAGS };
